import React, { JSX } from 'react';
import logo from './logo.svg';
import './App.css';
import AuthButton from './AuthButton';
const CLIENT_ID = "1034228451896-msgjqa08al4aq28j3g0outfum20mgkge.apps.googleusercontent.com";
const CLIENT_SECRET = "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";
const API_KEY = "AIzaSyAlSpsXrFF89vqmnJmtbVKUiwZBsvx3L7g";
enum Weekday {
  Mon = 1,
  Tue = 2,
  Wed = 3,
  Thu = 4,
  Fri = 5,
  Sat = 6,
  Sun = 0
}

type CalEvent = {
  title: string;
  start: Date;
  end: Date;
  allDay: boolean;
}

type DateInfo = {
  month:number;
  strMonth: string;
  day: number;
  showMonth: boolean;
  weekday: Weekday;  
  weekend: boolean;
  events: CalEvent[];
}


function App() {
  let gridData:DateInfo[][] = [];
  const year = 2025;
  let date = new Date(year, 0, 1);
  date.setDate(date.getDate() - date.getDay()+1);
  for (let i = 0; i < 27; i++) {
    gridData[i] = [];
    for (let j = 0; j < 14; j++) {
      gridData[i][j] = {
        strMonth: date.toLocaleString('default', { month: 'short' }),
        month: date.getMonth() + 1,
        day: date.getDate(),
        showMonth: false,
        weekday: date.getDay() as Weekday,
        weekend: (date.getDay() === 0 || date.getDay() === 6),
        events: []
      }
      if (date.getDate() === 1) {
        gridData[i][j].showMonth = true;
      }
      date.setDate(date.getDate() + 1);
    }
  }
  
  function makeGrid(rowsNum: number, colsNum: number) {
    let lines: JSX.Element[] = [];
    let rows: JSX.Element[] = [];
    for (let i = 0; i < rowsNum; i++) {
      for (let j = 0; j < colsNum; j++) {
        let classes = "cell";
        if (gridData[i][j].month % 2 !== 0) {
          classes += " monthOdd";
        }
        if (gridData[i][j].weekend) {
          classes += " weekEnd";
        }
        if (gridData[i][j].showMonth) {
          classes += " monthCell";
        }
        lines[j] = <div className={classes} key={j}>
          {gridData[i][j].showMonth && <div className="month">{gridData[i][j].strMonth}</div>}
          <div className="day">{gridData[i][j].day}</div>
        </div>;
      }
      rows[i] = <div className="row" key={i}>
        {lines.map((line, index) => line)}
      </div>;
    }
    return rows;
  }
  function makeGrid2(rowsNum: number, colsNum: number) {
    let lines: JSX.Element[] = [];
    let rows: JSX.Element[] = [];
    for (let i = 0; i < rowsNum; i++) {
      for (let j = 0; j < colsNum; j++) {
        let classes = "cell";
        
        lines[j] = <div className={classes} key={j}>
          
        </div>;
      }
      rows[i] = <div className="row" key={i}>
        {lines.map((line, index) => line)}
      </div>;
    }
    return rows;
  }
  return (
    <>
      <div style={{position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
        <AuthButton />
      </div>
      <div className='yearWatermark'><span>{year}</span></div>
      <div className='grid'>
        {makeGrid(27, 14)}
      </div>
    </>
  );
}

export default App;
